import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { simInfoColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getSimInfo } from "../../../../api/sim";

const COPY_KEYS = ["id", "iccid", "msisdn", "status", "plan", "created_at", "last_updated"];

const OPNSimInfoBatch = () => (
  <BatchDetail
    title="Sim Info"
    apiGet={__getSimInfo}
    client={CLIENTS.opn}
    columnsFactory={(ctx) => simInfoColumns({ ...ctx, showPlan: true })}
    copyKeys={COPY_KEYS}
    exportAction="sim_info"
    showTerminate
    terminateOperation="sim_info"
  />
);

export default OPNSimInfoBatch;
